module.exports = __webpack_public_path__ + "img/icon5.58b3a69e.png";